var details = (function() { 
  function toggle() {
    const details = document.querySelector('[data-js="toggle"]');
    
    // When details exists
    if (details) {
      // Show an overlay on the details toggler click
      var trigger = function () {
        document.addEventListener('click', function (e) {
          if (e.target.closest('[data-js="toggler"]')) {
            e.preventDefault();
            e.target.closest('[data-js="toggle"]').classList.toggle('gdpr-toggle--open');
          }
        }, false);
      };
      trigger();
    }
  }
  
  function close() {
    const details = document.querySelector('[data-js="toggle"]');
    // When details exists
    if (details) {
        
        // Show an overlay on the details toggler click
        var trigger = function () {
          details.classList.remove('gdpr-toggle--open');
        };
        trigger();
    }
  }

  return {
      toggle: toggle,
      close: close
  }
}());

export { details }